module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-plus-6b0d9997.svg";